import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d87db11&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87db11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d87db11')) {
      api.createRecord('4d87db11', component.options)
    } else {
      api.reload('4d87db11', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d87db11&scoped=true", function () {
      api.rerender('4d87db11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen-product/limit/index.vue"
export default component.exports